import { render, staticRenderFns } from "./TFAuth.vue?vue&type=template&id=6b0b4e9a&scoped=true&"
import script from "./TFAuth.vue?vue&type=script&lang=js&"
export * from "./TFAuth.vue?vue&type=script&lang=js&"
import style0 from "./TFAuth.vue?vue&type=style&index=0&id=6b0b4e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b4e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
